<template>
  <h1>LifeQuote Fees</h1>
  <div id="calculator">
    <p>
      Using LifeQuote to administer your protection business saves you three hours per case*, freeing you to meet and advise more clients. This time-saving allows advisers who use LifeQuote Administration to write 20% more protection cases every month.
    </p>
    <p>
      {{companyName !== "" ? companyName + " existing mortgage to protection conversion rate" : "Existing mortgage to protection conversion rate"}}
      <b>{{conversionRate}}%</b>
      (brought forward from previous current revenue page)
    </p>
    <p>{{companyName !== "" ? companyName + " new mortgage to protection conversion rate" : "New mortgage to protection conversion rate"}}
      <b>{{projectedConversionRate}}%</b>
      if using LifeQuote Administration
    </p>
    <p>The table below outlines our fees. The maximum amount you will pay is £95 per case. </p>
      

    <table id="fee-table">
      <!-- Table header -->
      <thead>
        <tr>
            <th scope="col">Application Type</th>
            <th scope="col">Fee</th>
            <th scope="col"><div>No. Apps <img class="img-help" src="../assets/icons/help-white.svg" @click="toggleHelp"/></div>
              <Transition name="fade">
                <div id="table-help" v-if="showHelp">
                  <div class="help-text">Based on your existing mortgage to protection conversion rate.</div>
                </div>
              </Transition>
            </th>
            <th scope="col">Cost</th>
        </tr>
      </thead>
      <!-- Table body -->
      <tbody>
        <tr>
            <td>Application submitted and the administration used, irrespective of whether it is placed on risk, declined, postponed or abandoned</td>
            <td class="text-mid">£{{submittedWithAdminCharge}}</td>
            <td class="text-mid">{{projectedSubmissionsWithAdmin}}</td>
            <td class="text-mid">£{{projectedSubmissionWithAdminCost}}</td>
        </tr>
        <tr>
            <td>Application submitted and placed on risk immediately, without administration</td>
            <td class="text-mid">£{{submittedImmediateOnRiskCharge}}</td>
            <td class="text-mid">{{projectedImmediateOnRisk}}</td>
            <td class="text-mid">£{{projectedImmediateOnRiskCost}}</td>
        </tr>
        <tr>
            <td>Application abandons before administration or client doesn't proceed with policy, pre or post submission</td>
            <td class="text-mid">£{{abandonedCharge}}</td>
            <td class="text-mid">{{projectedAbandonments}}</td>
            <td class="text-mid">£{{projectedAbandonmentsCost}}</td>
        </tr>
        <tr class="summary-row">
            <td>Total cost per month</td>
            <td></td>
            <td></td>
            <td class="text-mid">£{{projectedTotalCost}}</td>
        </tr>
      </tbody>
    </table>
    <div id="form-footer">
      <div class="button-wrapper back-button-wrapper">
        <BtnBack title="Back"/>
      </div>
      <div class="button-wrapper next-button-wrapper">
        <BtnNext title="Next" currentPage="fees" />
      </div>
    </div>
  </div>
</template>

<script>
import BtnNext from './BtnNext.vue'
import BtnBack from './BtnBack.vue'
export default {
  data () {
    return {
      showHelp: false
    }
  },
  props: {
  },
  methods:{
    toggleHelp() {
      this.showHelp = !this.showHelp;
   }
  },
  computed: {
      companyName: {
        get () {
          return this.$store.state.company.name
        }
      },
      conversionRate: {
        get () {

          return this.$store.state.currentRevenues.mortgages.monthlyAvgSignup > 0
            ? (100 / this.$store.state.currentRevenues.mortgages.monthlyAvgSignup) * this.$store.state.currentRevenues.life.cases
            : 0
        }
      },
      submittedWithAdminCharge: {
        get () {
          return this.$store.state.charges.submittedWithAdmin
        }
      },
      submittedImmediateOnRiskCharge: {
        get () {
          return this.$store.state.charges.submittedImmediateOnRisk
        }
      },
      abandonedCharge: {
        get () {
          return this.$store.state.charges.abandoned
        }
      },
      projectedConversionRate: {
        get () {
          return this.conversionRate * 1.2
        }
      },
      mortgageCases:{
        get () {
          return this.$store.state.currentRevenues.mortgages.monthlyAvgSignup
        }
      },
      projectedSubmissionsWithAdmin:{
        get () {
          return this.$store.getters.projectedSubmissionsWithAdmin
        }
      },
      projectedAbandonments:{
        get () {
          return this.$store.getters.projectedAbandonments
        }
      },
      projectedImmediateOnRisk:{
        get () {
          return this.$store.getters.projectedImmediateOnRisk
        }
      },
      projectedSubmissionWithAdminCost:{
        get () {
          return this.$store.getters.projectedSubmissionWithAdminCost
        }
      },
      projectedAbandonmentsCost:{
        get () {
          return this.$store.getters.projectedAbandonmentsCost
        }
      },
      projectedImmediateOnRiskCost:{
        get () {
          return this.$store.getters.projectedImmediateOnRiskCost
        }
      },
      projectedTotalCost:{
        get () {
          return this.projectedSubmissionWithAdminCost + this.projectedAbandonmentsCost + this.projectedImmediateOnRiskCost
        }
      },
      mortgageIncome: {
        get () {
          return this.$store.state.currentRevenues.mortgages.monthlyAvgSignup * this.$store.state.currentRevenues.mortgages.appFee
        }
      },
      lifeIncome: {
        get () {
          return this.$store.state.currentRevenues.life.cases * this.$store.state.currentRevenues.life.avgCommission
        }
      },
      binsIncome: {
        get () {
          return this.$store.state.currentRevenues.bins.cases * this.$store.state.currentRevenues.bins.avgCommission
        }
      },
      overheads: {
        get (){
          return this.$store.state.totalOverheads
        }
      }
  },
  components: {
    BtnBack,
    BtnNext
  }
}
</script>